module.exports = __webpack_public_path__ + "static/media/IntheKitchenwithYeYe_crop.a7c4cb96.jpg";